export const STATUS = {
    NOT_STARTED: 0,
    FETCHING: 1,
    SUCCESS: 2,
    FAILED: 3,
}